import React, { useEffect } from "react";
import Routes from "./Routes/Routes";
import * as Sentry from "@sentry/react";
import decodeJWT from "./lib/decodeJWT";

const App = () => {
  const tokenDetails = decodeJWT(localStorage.getItem("token")) || null;

  useEffect(() => {
    if (tokenDetails?.user && process.env.REACT_APP_ENV !== "development") {
      // Produktly script, make sure to copy-paste from the dashboard, so that your token is included
      (function (w, d, f) {
        var a = d.getElementsByTagName("head")[0];
        var s = d.createElement("script");
        s.async = 1;
        s.src = f;
        s.setAttribute("id", "produktlyScript");
        s.dataset.clientToken =
          "0fea50a68d512f5e941c230157652c828b97689de5936556687738341a616f51030f203a8651767c0459844d1953a5a245dd5b1856b443760debd3bce7946769afbdada9d630850e805b4c5df467407dccd1033aab218888774246344264a53e418bb588";
        a.appendChild(s);
      })(window, document, "https://public.produktly.com/js/main.js");
    }
  }, [tokenDetails?.user]);

  return (
    <div className="App">
      <Routes />
    </div>
  );
};

export default Sentry.withProfiler(App);
